import QuestionSetsParser from 'gw-portals-questionsets-js';
import MetadataDrivenParser from 'gw-portals-driven-ui-js/MetadataDrivenParser';
import ComponentUtil from 'gw-portals-util-js/ComponentUtil';
import _ from 'lodash';

let _MetadataDrivenUIService;

const LOBs = {
    'ho': 'homeowners',
    'pa': 'personalAuto',
    'bop': 'businessOwners'
};

class PrequalQuestionsSetCtrl {

    constructor($scope, submissionViewModel, MetadataDrivenUIService, LOCALE_CHANGE_EVENT_NAME, lob) {
        this.lob = lob;
        this._setCtrlParams = ComponentUtil.setCtrlParams(this, $scope);
        this.submissionVm = submissionViewModel();

        $scope.$on(LOCALE_CHANGE_EVENT_NAME, () => {
            this.renderMetadata();
        });
        _MetadataDrivenUIService = MetadataDrivenUIService;
        this.next = this.next.bind(this);
    }

    _init() {
        this.loading = true;
        this.renderMetadata();
    }

    renderMetadata() {
        _MetadataDrivenUIService.getPresentationMetadata(`quoteandbind-${this.lob}.{SEGMENT}.pre-qualification`).then(questionsSetPresentationMetadata => {

            const {viewModel: questionSetsViewModel, presentationMetadata} = new QuestionSetsParser(this.questionSetsSubmissionModel.value);

            // Remove layout provided by QuestionSetsParser and use flavor instead
            Reflect.ownKeys(presentationMetadata.fields).forEach(fieldName =>{
                const field = presentationMetadata.fields[fieldName];
                if (field.layout === 'reversed') {
                    field.dataProps = _.merge({}, field.dataProps, {flavor: 'reversed'});
                    Reflect.deleteProperty(field, 'layout');
                }
            });

            questionsSetPresentationMetadata = _.merge({}, presentationMetadata, questionsSetPresentationMetadata);
            questionsSetPresentationMetadata.content = questionsSetPresentationMetadata.content || presentationMetadata.content;

            const {className: preQualClassName, title: preQualTitle} = questionsSetPresentationMetadata;
            const presentationData = new MetadataDrivenParser(questionsSetPresentationMetadata, questionSetsViewModel).parsePageContent();
            const loading = false;

            this._setCtrlParams({
                preQualClassName,
                preQualTitle,
                questionSetsViewModel,
                presentationData,
                loading
            });
        });
    }

    next(nextFn, form) {
        nextFn(this.submissionVm, form.valid);
    }

    get questionSetsSubmissionModel() {
        const lob = LOBs[this.lob];
        return this.submissionVm.lobData[lob].preQualQuestionSets;
    }
}

export default PrequalQuestionsSetCtrl;